import { createFileRoute } from "@tanstack/react-router";

import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import CheckinFormBuilder from "@/modules/performance/admin/components/checkin-form/CheckinFormBuilder";

export const Route = createFileRoute(
  "/admin/_panel/_performance/performance/checkins-meetings/forms/create",
)({
  component: Component,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(
      context.user,
      "performance.performance-checkin-form.create",
    );

    return {
      compactMenu: true,
      hideCrumb: true,
      crumb: [
        {
          label: context.t("Create", { ns: "core.shared" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
});

function Component() {
  return <CheckinFormBuilder />;
}
